export default el => {
    const btn = el.querySelector("button");
    const inputs = el.querySelectorAll("input");
    const value = el.querySelector(".value");
    const count = el.querySelector(".count");

    inputs.forEach(input => {
        input.addEventListener("change", () => {
            update();
        })
    });

    el.addEventListener("change", () => {
        update();
    })

    btn.addEventListener("click", () => {
        el.classList.toggle("active");
    })

    document.addEventListener("click", (e) => {
        if (!el.contains(e.target)) {
            el.classList.remove("active");
        }
    })

    const update = () => {
        const checked = el.querySelectorAll("input:checked");

        if (value) {
            var res = [];

            checked.forEach(item => {
                res.push(item.dataset.title);
            }) 

            value.innerHTML = res.join(", ").toLowerCase();
        }

        if (count) {
            count.classList[checked.length == 0 ? "add" : "remove"]("inactive")
            count.innerHTML = checked.length;
        }
    }
}